import { render, staticRenderFns } from "./qr-info.vue?vue&type=template&id=132d2954&"
import script from "./qr-info.vue?vue&type=script&lang=js&"
export * from "./qr-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports